<template>
  <div id="certidoesUgsWrapper">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres titulo="Certidões de UGs" breakpoint="md">
          <template #customContent>
            <b-button
              :disabled="
                loadingRelatorio ||
                !ugSelecionada ||
                basesLegaisPendentes.length > 0
              "
              variant="outline-secondary"
              class="d-inline-flex align-items-center mr-2"
            >
              <b-spinner small v-if="loadingRelatorio" class="mr-2"></b-spinner>
              <font-awesome-icon
                v-else
                icon="fa-solid fa-file-arrow-down"
                class="mr-2"
              />
              <span>Relatório</span>
            </b-button>

            <multiselect
              v-model="ugSelecionada"
              :allow-empty="true"
              class="wrapper-multiselect-sagres"
              :close-on-select="true"
              deselect-label=""
              label="Nome"
              :loading="loadingUgs"
              @select="carregarBasesLegais"
              open-direction="bottom"
              :options="ugs"
              placeholder="Selecione uma UG"
              :searchable="true"
              :show-labels="false"
              track-by="Codigo"
              @input="listarDadosUG"
            >
              <template slot="noOptions">
                <small><i>Erro ao obter dados.</i></small>
              </template>
              <template slot="noResult">
                <i>Sem resultados.</i>
              </template>
            </multiselect>
          </template>
        </header-sagres>
      </template>
      <b-card-body>
        <div v-if="!ugSelecionada">
          <b-alert show variant="info" class="my-5">
            Selecione uma UG para visualizar as certidões
          </b-alert>
        </div>
        <b-spinner v-if="loadingDados" label="Carregando..." class="my-5" />
        <div v-else-if="!loadingDados && ugSelecionada && dadosUG.length === 0">
          <b-alert show variant="info" class="my-5">
            Nenhum dado encontrado para a UG selecionada.
          </b-alert>
        </div>
        <div v-else id="certidoesAnoWrapper">
          <b-card
            v-for="(certidoesAno, index) in dadosUG"
            :key="index"
            class="shadow mb-4"
            no-body
          >
            <template #header>
              <h6
                class="mb-0 titulo-mobile font-weight-bold d-flex justify-content-between align-items-center"
              >
                <b-link
                  @click.prevent="
                    abreModal(certidoesAno.CodProtocolo, certidoesAno.titulo)
                  "
                  >{{ certidoesAno.titulo }}</b-link
                >

                <div class="d-flex align-items-center gap-3">
                  <span class="mr-3"
                    >Pendências: {{ certidoesAno.pendencias }}</span
                  >
                  <b-button
                    size="sm"
                    v-b-tooltip.hover
                    title="Adicionar item"
                    @click="abrirModalAdicionarItem(certidoesAno)"
                  >
                    <font-awesome-icon icon="plus" class="mr-2" />
                    <span>Adicionar Item</span>
                  </b-button>
                  <b-button
                    size="sm"
                    v-b-toggle="'collapse-' + index"
                    aria-controls="'collapse-' + index"
                    variant="outlined"
                    class="ml-2"
                    @click="toggle(index)"
                  >
                    <font-awesome-icon
                      :icon="
                        openStates[index]
                          ? 'fa-solid fa-angle-down'
                          : 'fa-solid fa-angle-right'
                      "
                    />
                  </b-button>
                </div>
              </h6>
            </template>
            <b-collapse
              :id="'collapse-' + index"
              class="mt-2"
              @shown="setOpen(index, true)"
              @hidden="setOpen(index, false)"
            >
              <TabelaCertidoes
                v-if="certidoesAno.ItensAnalisados.length"
                :itens="certidoesAno.ItensAnalisados"
                @editarItem="(cert) => editarItem(certidoesAno, cert)"
              />

              <b-alert v-else variant="warning" class="mb-0" show>
                <b-icon icon="exclamation-triangle" class="mr-2" />
                Sem itens analisados para este ano
              </b-alert>
            </b-collapse>
          </b-card>
        </div>
      </b-card-body>
    </b-card>
    <ModalEdicaoItemDeCertidao
      v-if="mostrarModalEdicaoItem"
      :bases="basesLegaisModal"
      :certidaoOriginal="certidaoOriginal"
      :infoAno="certAnoModalEdicao"
      :loading="loadingDropdowns"
      @fecharModal="fecharModalEdicao"
      @salvou="atualizarCertidoes"
    />

    <b-modal
      id="modal-processo"
      :title="tituloModal"
      header-bg-variant="secondary"
      header-text-variant="light"
      size="xl"
      hide-footer
      centered
    >
      <protocoloProcessoComponenteVue
        :detalhe="detalhesProcesso"
        :modal="true"
      />
    </b-modal>
  </div>
</template>

<script lang="ts">
import certidoresUgService from "@/services/interno/certidoesUgService";
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { CertidoesAno } from "@/types/interno/certidoes-ugs/certidoes-ano";
import TabelaCertidoes from "@/components/interno/certidoes/TabelaCertidoes.vue";
import ModalEdicaoItemDeCertidao from "@/components/interno/certidoes/ModalEdicaoItemDeCertidao.vue";
import { BaseLegal } from "@/types/interno/certidoes-ugs/base-legal";
import { Certidao } from "@/types/interno/certidoes-ugs/certidao";
import protocoloProcessoComponenteVue from "@/components/processo-eletronico/protocolo-processo-componente.vue";
import protocoloService from "@/services/processos-eletronicos/protocoloService";
import { BaseLegalPendente } from "@/types/interno/certidoes-ugs/base-legal-pendente";
const CompProps = Vue.extend({
  name: "CertidoesUgs",
  components: {
    HeaderSagres,
    ModalEdicaoItemDeCertidao,
    Multiselect,
    TabelaCertidoes,
    protocoloProcessoComponenteVue,
  },
});

@Component
export default class CertidoesUgs extends mixins(UtilsTS, CompProps) {
  basesLegais: BaseLegal[] = [];
  basesLegaisPendentes: BaseLegalPendente[] = [];
  basesLegaisModal: BaseLegal[] = [];
  certAnoModalEdicao: CertidoesAno | null = null;
  certidaoOriginal: Certidao | null = null;
  dadosUG: CertidoesAno[] = [];
  loadingDados = false;
  loadingDropdowns = false;
  loadingRelatorio = false;

  loadingUgs = false;
  mostrarModalEdicaoItem = false;
  ugs: UnidadeGestoraResumida[] = [];
  ugSelecionada: UnidadeGestoraResumida | null = null;
  detalhesProcesso: Record<string, unknown> = {};
  openStates: boolean[] = [];
  tituloModal = "";
  async mounted(): Promise<void> {
    await this.carregarUgs();
  }

  toggle(index: number): void {
    Vue.set(this.openStates, index, !this.openStates[index]);
  }

  setOpen(index: number, val: boolean): void {
    Vue.set(this.openStates, index, val);
  }

  abrirModalAdicionarItem(ca: CertidoesAno): void {
    ca.codUG = this.ugSelecionada?.Codigo || "";
    this.certAnoModalEdicao = ca;
    const basesLegaisDesteAno = ca.ItensAnalisados.map(
      (item) => item.IdBaseLegal
    );
    this.basesLegaisModal = this.basesLegais.filter(
      (bl) => !basesLegaisDesteAno.includes(bl.Id)
    );
    this.mostrarModalEdicaoItem = true;
  }

  async atualizarCertidoes(tipo: string, blPendentes: BaseLegalPendente[]) {
    if (tipo === "e") {
      this.$toast.success("Item editado com sucesso!");
    }

    if (tipo === "c") {
      this.$toast.success("Item criado com sucesso!");
    }

    try {
      if (!this.ugSelecionada || !this.ugSelecionada.Codigo) {
        this.dadosUG = [];
        return;
      }
      this.dadosUG = await certidoresUgService.buscarDadosUg(
        this.ugSelecionada.Codigo
      );
      this.basesLegaisPendentes = [];
      this.basesLegaisPendentes = blPendentes;
      this.calcularPendencias();
      this.openStates = this.dadosUG.map(() => false);
      this.fecharModalEdicao();
    } catch (e: unknown) {
      this.dadosUG = [];
      this.tratarError(e);
    }
  }

  async carregarBasesLegais(): Promise<void> {
    try {
      this.loadingDropdowns = true;
      const codigo = this.ugSelecionada?.Codigo;
      if (!codigo) {
        this.basesLegais = [];

        return;
      }
      this.basesLegais = await certidoresUgService.buscarBasesLegais(codigo);
    } catch (e: unknown) {
      this.basesLegais = [];
      this.tratarError(e);
    } finally {
      this.loadingDropdowns = false;
    }
  }
  async carregarUgs(): Promise<void> {
    this.loadingUgs = true;
    try {
      this.ugs = await certidoresUgService.buscarUGs();
    } catch (e: unknown) {
      this.ugs = [];
      this.tratarError(e);
    } finally {
      this.loadingUgs = false;
    }
  }

  editarItem(ca: CertidoesAno, item: Certidao): void {
    ca.codUG = this.ugSelecionada?.Codigo || "";
    this.certAnoModalEdicao = ca;
    const basesLegaisDesteAno = ca.ItensAnalisados.map(
      (item) => item.IdBaseLegal
    );
    this.basesLegaisModal = this.basesLegais.filter(
      (bl) => !basesLegaisDesteAno.includes(bl.Id)
    );
    const baseAtual = this.basesLegais.find((bl) => bl.Id === item.IdBaseLegal);
    if (baseAtual) {
      this.basesLegaisModal.push(baseAtual);
    }
    this.certidaoOriginal = item;
    this.mostrarModalEdicaoItem = true;
  }

  async validarBasesLegais(codUg: string): Promise<void> {
    try {
      this.loadingRelatorio = true;
      this.basesLegaisPendentes = await certidoresUgService.validarBasesLegais(
        codUg
      );
    } catch (e: unknown) {
      this.basesLegaisPendentes = [];
      this.tratarError(e);
    } finally {
      this.loadingRelatorio = false;
    }
  }

  fecharModalEdicao(): void {
    this.mostrarModalEdicaoItem = false;
    this.certidaoOriginal = null;
    this.certAnoModalEdicao = null;
  }

  async listarDadosUG(): Promise<void> {
    if (this.ugSelecionada?.Codigo)
      await this.validarBasesLegais(this.ugSelecionada.Codigo);
    try {
      this.loadingDados = true;
      if (!this.ugSelecionada || !this.ugSelecionada.Codigo) {
        this.dadosUG = [];
        return;
      }
      this.dadosUG = await certidoresUgService.buscarDadosUg(
        this.ugSelecionada.Codigo
      );
      this.calcularPendencias();
      this.openStates = this.dadosUG.map(() => false);
    } catch (e: unknown) {
      this.dadosUG = [];
      this.tratarError(e);
    } finally {
      this.loadingDados = false;
    }
  }

  calcularPendencias() {
    this.loadingRelatorio = true;
    this.basesLegaisPendentes.forEach((baselegalpendente) => {
      const itemEncontrado = this.basesLegais.find(
        (baselegal) => baselegal.Id === baselegalpendente.IdBaseLegal
      );

      baselegalpendente.Nome = itemEncontrado?.Descricao;
    });

    this.dadosUG.forEach((itemAno) => {
      const pendencias = this.basesLegaisPendentes.filter(
        (baselegal) => baselegal.Exercicio === itemAno.Exercicio
      );

      itemAno.pendencias = pendencias.length;
    });
    this.loadingRelatorio = false;
  }

  async abreModal(codigo: number, titulo: string) {
    try {
      const response = await protocoloService.getDetalheProtocoloProcesso(
        codigo
      );
      this.detalhesProcesso = response as Record<string, unknown>;
      this.tituloModal = titulo;
      this.$bvModal.show("modal-processo");
    } catch (e: unknown) {
      this.tratarError(e);
    }
  }
}
</script>

<style scoped>
::v-deep div.multiselect.wrapper-multiselect-sagres {
  line-height: 20px;
  font-weight: normal;
  min-width: 30vw;
}
</style>
